<template>
  <div class="contact pb4 w-100" >
    <div class="w-100 cover" :style="{'height': mobile ? '40vh' : '60vh'}"></div>

    <div class="center tc w-80 pt4-ns" :class="[mobile ? 'w-100' : 'dt h7']">
      <div class="info w-40-ns mv3" :class="[mobile ? 'tc w-100' : 'dtc tl v-top']">
        <div class="w-90-ns w-100 tl f5" :class="[mobile ? 'pl2 center' : 'tl']" >
          <!-- <div class="f3 b ps-blue pb2">{{info.name}}</div> -->
          <!-- <div class="w-70-ns w-100 tl mb3"><img :src="require(`@/assets/${info.logo}`)" /></div> -->
          <div class="w-100-ns w-100 dib f3-ns f4 b pb3 ps-blue" :class="[mobile ? 'tc' : 'tl']" >
            Contact us for a free estimate!
          </div>
          <div class="pa1"><a class="link" :href="info.tel"><i class="fa fa-phone mr3" style="font-size:20px"/>{{info.phone}}</a></div>
          <div class="pa1"><a class="link" :href="info.mail"><i class="fa fa-envelope-o mr2"/> {{info.email}}</a></div>
          <div class="pa1"><a class="link" :href="info.directions" target="_blank"><i class="fa fa-map-marker mr3"/> {{info.address}}</a></div>
        </div>
        <iframe class="map w-80 h-100 pv3" :style="{'maxHeight': mobile ? '250px' : '350px', 'height': mobile ? '300px' : '350px' }" :src="info.map" frameborder="0" style="border:0;" allowfullscreen=""></iframe>
      </div>

      <div class="w-40-ns" :class="[mobile ? 'w-100' : 'dtc v-mid']">
          <div class="w-80-ns w-100 dib f3-ns f4 b pb3 ps-blue" :class="[mobile ? 'tc' : 'tc']" >
            Fill out the form below and we'll contact you within 24 hours. 
          </div>
          <Form class=""/>
      </div>
    </div>
  </div>
</template>

<script>
import Form from '@/components/Form.vue'
export default {
  name: 'Contact',
  props: ['info', 'mobile'],
  components: { Form }
}
</script>

<style scoped>
.map {
  border: white 1px solid;
}
a.link {
  background-color: transparent;
  color: #0f376f;
  transition: ease .5s;
  font-weight: bold;
  padding: .25rem;
}
a.link:hover {
  background-color: #0f376f;
  color: #fff;
  transition: ease .5s;
  padding: .25rem;
}

.contact {
  background-image: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0)), url("https://images.unsplash.com/photo-1516541196182-6bdb0516ed27?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2134&q=80");
}

.cover {
  /* background: url('https://images.unsplash.com/photo-1503387762-592deb58ef4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2089&q=80'); */
  background: url('../assets/bg-contact.jpg');
  height: 40vh;
  background-position: 20% 40%;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;    
  text-align: center;
  margin: auto;
}
</style>
